import Swiper from 'swiper';
import { A11y, Controller, EffectFade, Navigation, Pagination, Thumbs } from 'swiper/modules';
import { initDialog, openDialog } from '../common/dialog';

window.CI360 = {
  notInitOnLoad: true,
};

export const initProductGallery = () => {
  const product_thumbnails_selector = '.swiper-thumbs';
  const product_cover_selector = '.swiper-cover';

  var productGalleryThumbs = new Swiper(product_thumbnails_selector, {
    modules: [Thumbs, A11y],
    direction: 'vertical',
    spaceBetween: 16,
    slidesPerView: 3,
    watchSlidesProgress: true,
  });

  new Swiper(product_cover_selector, {
    modules: [Thumbs, Navigation, Pagination, EffectFade, A11y, Controller],
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 16,
    effect: 'fade',
    thumbs: {
      swiper: productGalleryThumbs,
    },
    navigation: {
      nextEl: '.btn-thumb-next',
      prevEl: '.btn-thumb-prev',
    },
    pagination: {
      enabled: true,
      el: '.swiper-pagination-gallery',
      clickable: true,
    },
    breakpoints: {
      700: {
        slidesPerView: 1,
        centeredSlides: false,
        pagination: {
          enabled: false,
        },
      },
    },
  });
};

export const initProductGalleryDialog = () => {
  const images = document.querySelectorAll('.swiper-cover .swiper-slide img');
  const swiper_dialog = document.querySelector('.swiper-dialog');
  const swiper_wrapper = swiper_dialog.querySelector('.swiper-wrapper');

  const dialog = initDialog('product-gallery-dialog');

  const swiper_dialog_constructor = new Swiper(swiper_dialog, {
    modules: [Navigation, A11y],
    allowTouchMove: false,
    navigation: {
      nextEl: '.btn-dialog-next',
      prevEl: '.btn-dialog-prev',
    },
  });

  images.forEach(image => {
    image.addEventListener('click', () => {
      swiper_dialog_constructor.slideTo(image.getAttribute('data-index'), 0);
      openDialog(dialog);
    });

    let div = document.createElement('div');
    div.classList.add('swiper-slide');

    let img = document.createElement('img');
    img.src = image.getAttribute('data-dialog-src');
    img.setAttribute('draggable', 'false');

    div.appendChild(img);
    swiper_wrapper.appendChild(div);
  });
};

export const init360ViewEvent = () => {
  const view360 = document.getElementById('360-view');

  if (view360) {
    const dialog = initDialog('product-360-dialog');

    view360.addEventListener('click', function () {
      window.CI360.init();
      openDialog(dialog);
    });

    view360.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        window.CI360.init();
        openDialog(dialog);
      }
    });
  }
};
